var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "documents" }, [
    _c("div", { staticClass: "nr_container_content" }, [
      _c("div", { staticClass: "documents__crumbs" }, [
        _c(
          "ul",
          { staticClass: "documents__crumbs-list" },
          _vm._l(_vm.cat, function (link, idx) {
            return _c(
              "li",
              { key: idx, staticClass: "documents__crumbs-item" },
              [
                _c("a", {
                  staticClass: "documents__crumbs-link",
                  class: { "documents__crumbs-link--active": link.active },
                  attrs: { href: link.path },
                  domProps: { textContent: _vm._s(link.name) },
                }),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "documents__cards" },
        _vm._l(_vm.documents, function (link, idx) {
          return _c("div", { key: idx, staticClass: "documents__cards-card" }, [
            _c("a", {
              staticClass: "documents__cards-link",
              attrs: { href: link.path, target: "_blank" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "documents__cards-card--container" }, [
              _c("div", { staticClass: "documents__cards-icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "48",
                      height: "48",
                      viewBox: "0 0 48 48",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M9 0C7.35 0 6 1.35 6 3V45C6 46.65 7.35 48 9 48H39C40.65 48 42 46.65 42 45V12L30 0H9Z",
                        fill: "#E2E5E7",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M33 12H42L30 0V9C30 10.65 31.35 12 33 12Z",
                        fill: "#B0B7BD",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: { d: "M42 21L33 12H42V21Z", fill: "#CAD1D8" },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "documents__cards-name",
                domProps: { textContent: _vm._s(link.name) },
              }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "documents__cards-info" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    link.date +
                      " | " +
                      link.fileType.toUpperCase() +
                      " " +
                      link.fileSize +
                      "мб"
                  ) +
                  "\n        "
              ),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }